module.exports = __webpack_public_path__ + "img/operationsverstaendnis_hintergrund.515ada3e.jpg";